import {
  AfterViewInit,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import {CommonModule, LocationStrategy} from '@angular/common';
import {Field, LookupItemComponent} from "../../components/lookup-item";
import {window} from "rxjs";
import {
  Batch,
  BatchRpcService,
  DocumentRpcService,
  MessageService,
  MessageType,
  QueueItem, QueueRpcService,
  QueueType
} from "@alpha/services";
import {MultiItemHoverComponent} from "../../components/multi-item-hover/multi-item-hover.component";
import {Helpers} from "../../components/helpers";
import {ZXingScannerModule} from "@zxing/ngx-scanner";

@Component({
  selector: 'view-bookmarks',
  standalone: true,
  imports: [CommonModule, LookupItemComponent, ZXingScannerModule],
  templateUrl: './bookmarks.component.html',
  styleUrls: ['./bookmarks.component.scss']
})
export class BookmarksViewComponent implements OnInit {

  batches: Batch[] = []
  selected: string[] = []
  fields: Field[] = []
  loading: boolean = false;
  page:number = 2;

  constructor(private bs: BatchRpcService, private ds: DocumentRpcService, private ms: MessageService, private qs: QueueRpcService) {
    this.fields.push({label: 'AWB/BOL #', identifier: 'awb_bol_number'})
    this.fields.push({label: 'ETA', identifier: 'estimated_date_arrival'})
    this.fields.push({label: 'FDA Registration #', identifier: 'fda_registration'})
    this.fields.push({label: 'Facility Address', identifier: 'facility_address'})
    this.fields.push({label: 'TLC', identifier: 'barcodes', component: MultiItemHoverComponent})
    this.fields.push({label: 'Order Numbers', identifier: 'order_number', component: MultiItemHoverComponent})
    this.dummyData();
  }


  async ngOnInit() {
    this.batches = await this.bs.getBatchListBookmarked();
    this.loading = false;
    this.scrollEvent();
  }

  scrollEvent() {
    let lastPos = -1;
    let captures: number[] = [];

    document.querySelector('.dashboard__content')?.
    addEventListener('scroll', async (evt) => {
      const target: any = evt.target;
      let scrollTop = Math.floor(target.scrollTop+456);
      let scrollHeight = target.scrollHeight;
      if(Math.round(scrollTop) >= scrollHeight) {
        await this.loadMore();
      }
    })
  }

  async loadMore() {
    const batches = await this.bs.getBatchListBookmarked(this.page);
    if(batches.length > 0){
      this.page++;
      this.batches.push(batches)
    }
    console.log("Load more",this.page )
  }

  async onChange(evt: any) {

  }

  @HostListener('window:scroll', ['$event'])
  scroll(evt: any) {
    console.log(evt)
  }

  select(evt: any, batchId: string) {
    let disabled = ['svg', 'path', 'A']
    if (disabled.indexOf(evt.target.tagName) == -1) {
      this.selected.includes(batchId)
        ? (this.selected = this.selected.filter(s => s !== batchId))
        : this.selected.push(batchId);
    }
  }

  toggleSelection() {
    if (this.selected.length > 0) {
      this.selected = [];
    } else {
      this.selected = this.batches.map(d => d.bid);
    }
  }

  async download() {
    if (this.selected.length > 0) {
      const queue: QueueItem = {
        data: {
          batches: this.selected.filter(s => s != null),
          documents: [{dtid: 'F9E2DEDD-7B08-49D2-9262-D86724B49631', name: 'Pilot Packet'}],
          prefix: [],
          page: null
        },
        type: QueueType.ExportDocuments
      }

      await this.qs.queue.enqueue(async () => await this.qs.enqueue(queue));

      this.ms.set({
        message: `Batch documents are being processed`,
        type: MessageType.Success,
        delay: 2500,
      });

    }
  }


  dummyData() {
    this.loading = true;

    let data: any = {
      awb_bol_number: "...................",
      estimated_date_arrival: ".............. ......",
      fda_registration: "....................",
      facility_address: "...... .... ....... ... ....... ....",
      barcodes: ['....'],
      order_number: ['....'],
    }

    this.batches = [data, data, data, data, data]

  }
}
